/**
 * Shows the notice-only US cookie bar (`snippets/ora-us-cookie-notice.liquid`)
 * and hides it again for good once Accept is pressed.
 *
 * The bar is rendered `hidden` everywhere. It is shown only when Shopify's
 * Customer Privacy API places the visitor in the US *and* says no consent
 * banner is needed there -- which is what unticking the US in Shopify's cookie
 * banner regions does. Anywhere a banner is needed (the EU, UK, Quebec),
 * `shouldShowBanner()` is true, Consentmo shows its own, and this stays hidden.
 *
 * It never writes consent. Tracking is already allowed in the US before any
 * choice, Accept only records that the bar was seen, and an opt-out made on
 * the data sharing page or by Global Privacy Control is left exactly as it is.
 * Nothing on the page waits for this script, which is the point: the banner
 * this replaces is what held the Meta pixel back for seconds on every visit.
 */

const STORAGE_KEY = 'ora-us-notice-seen';
const notice = document.getElementById('ora-us-notice');

/** @returns {boolean} */
function alreadySeen() {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

function remember() {
  try {
    window.localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    // Private mode or blocked storage: the bar simply shows again next visit.
  }
}

function show() {
  if (!notice || !notice.hidden) return;
  notice.hidden = false;
  requestAnimationFrame(() => notice.classList.add('is-open'));
}

/**
 * @returns {boolean} true once the API answered, whatever it said.
 */
function decide() {
  const privacy = /** @type {any} */ (window).Shopify?.customerPrivacy;
  if (!privacy || typeof privacy.shouldShowBanner !== 'function') return false;

  let region = '';
  let needsBanner = true;
  try {
    region = String(privacy.getRegion?.() || '');
    needsBanner = privacy.shouldShowBanner() !== false;
  } catch {
    return true;
  }
  if (region.startsWith('US') && !needsBanner) show();
  return true;
}

if (notice) {
  notice.querySelector('[data-ora-us-notice-accept]')?.addEventListener('click', () => {
    remember();
    notice.classList.remove('is-open');
    notice.hidden = true;
  });

  if (notice.dataset.designMode === 'true') {
    show();
  } else if (!alreadySeen() && !decide()) {
    const shopify = /** @type {any} */ (window).Shopify;
    if (typeof shopify?.loadFeatures === 'function') {
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (/** @type {unknown} */ error) => {
        if (!error) decide();
      });
    } else {
      // No loader on this page: look again a few times while the API arrives.
      let tries = 0;
      const timer = window.setInterval(() => {
        tries += 1;
        if (decide() || tries >= 20) window.clearInterval(timer);
      }, 500);
    }
  }
}
